export default "__VITE_ASSET__D20DQD2M__"